import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type UiIconName =
  | 'search'
  | 'close'
  | 'list'
  | 'grid'
  | 'tree'
  | 'chevronRight'
  | 'chevronUp'
  | 'chevronDown'
  | 'more'
  | 'eye'
  | 'download'
  | 'check'
  | 'empty'
  | 'alert';

const PATHS: Record<UiIconName, string> = {
  search: 'M4 11a7 7 0 1 0 14 0 7 7 0 0 0-14 0M20 20l-3.5-3.5',
  close: 'M6 6l12 12M18 6L6 18',
  list: 'M4 6h16M4 12h16M4 18h16',
  grid: 'M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z',
  tree: 'M4 5h6M8 5v14M8 12h6M8 19h6M14 5h6M14 12h6M14 19h6',
  chevronRight: 'M9 5l7 7-7 7',
  chevronUp: 'M5 15l7-7 7 7',
  chevronDown: 'M5 9l7 7 7-7',
  more: 'M12 5.5v.01M12 12v.01M12 18.5v.01',
  eye: 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7zM9 12a3 3 0 1 0 6 0 3 3 0 0 0-6 0',
  download: 'M12 4v10M8 11l4 4 4-4M4 19h16',
  check: 'M5 12l5 5 9-10',
  empty: 'M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z',
  alert: 'M3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0M12 7v6M12 16.5v.5',
};

const SIZES: Partial<Record<UiIconName, number>> = { empty: 32, alert: 28, more: 15, list: 15, grid: 15, tree: 15 };

@Component({
  selector: 'de-ui-icon',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      [attr.stroke-width]="name() === 'more' ? 3 : name() === 'check' ? 2.5 : 1.75"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
      focusable="false"
      [attr.width]="size()"
      [attr.height]="size()"
    >
      <path [attr.d]="path()" />
    </svg>
  `,
  styles: [':host { display: inline-flex; }'],
})
export class DeUiIconComponent {
  readonly name = input<UiIconName>('file' as UiIconName);

  readonly path = computed(() => PATHS[this.name()]);
  readonly size = computed(() => SIZES[this.name()] ?? 14);
}
